import { useEffect, useState } from 'react'

export const useInitUtmMtsDengi = () => {
  const [isMtsDengi, setIsMtsDengi] = useState(false)

  useEffect(() => {
    if (window.location.search.includes('utm_source=mtsdengi')) {
      setIsMtsDengi(true)
      sessionStorage.setItem('isMtsDengi', 'true')
    } else {
      const isMtsDengiFromStorage = sessionStorage.getItem('isMtsDengi')

      if (isMtsDengiFromStorage) {
        setIsMtsDengi(isMtsDengiFromStorage === 'true')
      }
    }
  }, [])

  return { isMtsDengi, setIsMtsDengi }
}
